<template>
  <div class="row">
    <progress-component
      v-if="showProgress"
      :allEmployeesCounter="allEmployeesCounter"
      :totalEmployees="totalEmployees"
      :selectedEmployee="selectedEmployee"
      @progress-complete="handleProgressComplete"
    ></progress-component>
    <div class="col-12">
      <div class="card">
        <!-- {{ selectedEmployee.name }} -->
        <div class="card-header header-elements-inline">
          <h5 class="card-title">Payroll Report</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6 col-md-6 sol-sm-12">
              <div class="form-group">
                <label>Date:</label>
                <el-date-picker
                  ref="datePicker"
                  v-model="searchDate"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="to"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  :picker-options="pickerOptions"
                  format="MMM dd, yy"
                  @change="
                    dateChanged(searchDate);
                    disableButtons();
                  "
                ></el-date-picker>
                <div v-if="searchDateError">
                  <span>{{ searchDateMessage }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 sol-sm-12">
              <div class="form-group">
                <label>Employee:</label>
                <!-- this needs to be a ddl of employees -->
                <v-select
                  :options="users"
                  label="name"
                  v-model="selectedEmployee"
                  v-on:input="resetReport"
                  @input="disableButtons"
                ></v-select>
                <div v-if="searchEmployeeError">
                  <span>{{ searchEmployeeMessage }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              selectedEmployee != null ? selectedEmployee.id == 'all' : false
            "
            class="row mb-3"
          >
            <div class="col-12">
              <el-switch
                style="display: block"
                v-model="hideEmployeesWithNoHours"
                class="float-right"
                active-color="#13ce66"
                inactive-color="#ad466c"
                active-text="Hide employees with no hours"
                avtive-value="true"
              ></el-switch>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="float-left col-6">
                <!-- <span v-if="missingTimeCardError">{{missingTimeCardMessage}}</span> -->
                <el-tag v-if="missingTimeCardError" type="danger" effect="dark">
                  {{ missingTimeCardMessage }}
                </el-tag>
                <div
                  v-for="(duplicateTimeCard, index) in duplicateTimeCardErrors"
                  v-bind:key="`duplicateTimeCard_${index}`"
                >
                  <el-tag
                    v-if="duplicateTimeCard.error"
                    type="danger"
                    effect="dark"
                    class="mb-2"
                    style="height: auto; white-space: break-spaces"
                  >
                    {{ duplicateTimeCard.message }}
                  </el-tag>
                </div>
              </div>
              <div
                class="text-right button-container d-inline-flex float-right"
              >
                <el-checkbox
                  class="mr-2 whiteCheckboxText"
                  v-model="includeTimeCardData"
                >
                  Include timecard info in pdf
                </el-checkbox>
                <PayrollReportPDFv2
                  msg="Email"
                  ref="reportPDF"
                  class="button mr-2"
                  @email="emailReport"
                  :key="emailKey"
                  :selectedEmployee="selectedEmployee"
                  :isButtonDisabled="areButtonsDisabled"
                  :allEmployeesReportData="pdfAllEmployeesReportData"
                  :allEmployeesSelected="allEmployeesSelected"
                  :printData="pdfData"
                  :printTotals="pdfTotals"
                  :searchDate="searchDate"
                  :companyLogo="companyLogo.base64"
                  :statHoursWorked="statHoursWorked"
                  :statDaysWorked="statDaysWorked"
                  :statExemptDays="statExemptDays"
                  :statExemptHours="statExemptHours"
                  :multipleStats="multipleStats"
                  :includeTimeCardData="includeTimeCardData"
                  :jobSpecificTotals="jobSpecificTotals"
                  :reportTotals="reportTotals"
                ></PayrollReportPDFv2>

                <PayrollReportPDFv2
                  msg="Download"
                  ref="reportPDF"
                  class="button mr-2"
                  @download="downloadReport"
                  :key="downloadKey"
                  :selectedEmployee="selectedEmployee"
                  :isButtonDisabled="areButtonsDisabled"
                  :allEmployeesReportData="pdfAllEmployeesReportData"
                  :allEmployeesSelected="allEmployeesSelected"
                  :printData="pdfData"
                  :printTotals="pdfTotals"
                  :searchDate="searchDate"
                  :companyLogo="companyLogo.base64"
                  :statHoursWorked="statHoursWorked"
                  :statDaysWorked="statDaysWorked"
                  :statExemptDays="statExemptDays"
                  :statExemptHours="statExemptHours"
                  :multipleStats="multipleStats"
                  :includeTimeCardData="includeTimeCardData"
                  :jobSpecificTotals="jobSpecificTotals"
                  :reportTotals="reportTotals"
                ></PayrollReportPDFv2>

                <PayrollReportPDFv2
                  msg="Print"
                  ref="reportPDF"
                  class="button mr-2"
                  @print="printReport"
                  :key="printKey"
                  :selectedEmployee="selectedEmployee"
                  :isButtonDisabled="areButtonsDisabled"
                  :allEmployeesReportData="pdfAllEmployeesReportData"
                  :allEmployeesSelected="allEmployeesSelected"
                  :printData="pdfData"
                  :printTotals="pdfTotals"
                  :searchDate="searchDate"
                  :companyLogo="companyLogo.base64"
                  :statHoursWorked="statHoursWorked"
                  :statDaysWorked="statDaysWorked"
                  :statExemptDays="statExemptDays"
                  :statExemptHours="statExemptHours"
                  :multipleStats="multipleStats"
                  :includeTimeCardData="includeTimeCardData"
                  :jobSpecificTotals="jobSpecificTotals"
                  :reportTotals="reportTotals"
                ></PayrollReportPDFv2>
                <div class="text-right">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="searchCards"
                    :disabled="isSearchDisabled"
                  >
                    <span>Search</span>
                    <i v-if="isLoaderDisabled" class="icon-search4 ml-2"></i>
                    <spring-spinner
                      :animation-duration="3000"
                      :size="15"
                      color="white"
                      v-else
                      style="display: inherit; vertical-align: inherit"
                      class="ml-2"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- totals and table -->
    <div
      id="printReport"
      class="col-12"
      slot="pdf-content"
      v-if="!allEmployeesSelected && !hideEmployeeReport"
    >
      <div id="individualEmployeeContainer">
        <div class="row mt-3">
          <div v-if="selectedEmployee != null" class="col-12">
            <h2 class="float-left payrollHeader">
              {{ selectedEmployee.name }}
            </h2>
          </div>
        </div>

        <section class="row weekTable pdf-item" v-if="printTotals.length > 0">
          <div class="col-3">
            <div class="card">
              <div class="card-header hoursSubHeader">Total Hours</div>
              <div class="card-body">
                <h6 class="card-title hoursTotals">
                  {{ reportTotals.total.toFixed(2) }}
                </h6>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="card">
              <div class="card-header hoursSubHeader">Regular Hours</div>
              <div class="card-body">
                <h6 class="card-title hoursTotals">
                  {{ reportTotals.regularTotal.toFixed(2) }}
                </h6>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div class="card">
              <div class="card-header hoursSubHeader">OT Hours</div>
              <div class="card-body">
                <h6 class="card-title hoursTotals">
                  {{ reportTotals.otTotal.toFixed(2) }}
                </h6>
              </div>
            </div>
          </div>
          <div v-show="reportTotals.travelTimeTotal > 0" class="col-3">
            <div class="card">
              <div class="card-header hoursSubHeader">Travel Time</div>
              <div class="card-body">
                <h6 class="card-title hoursTotals">
                  {{ reportTotals.travelTimeTotal.toFixed(2) }}
                </h6>
              </div>
            </div>
          </div>
          <div v-show="reportTotals.onCallHoursTotal > 0" class="col-3">
            <div class="card">
              <div class="card-header hoursSubHeader">On Call Hours</div>
              <div class="card-body">
                <h6 class="card-title hoursTotals">
                  {{ reportTotals.onCallHoursTotal.toFixed(2) }}
                </h6>
              </div>
            </div>
          </div>
          <div v-show="reportTotals.statTotal > 0 || statError" class="col-3">
            <div class="card d-flex flex-row justify-content-between">
              <div>
                <div>
                  <div class="card-header hoursSubHeader mb-0 pb-0">
                    {{ statError ? statError : 'Stat' }}
                  </div>
                </div>

                <div class="card-body">
                  <h6 class="card-title hoursTotals">
                    {{ statError ? '--' : reportTotals.statTotal.toFixed(2) }}
                  </h6>
                </div>
              </div>
              <div v-if="!statError">
                <div class="hoursSubHeader mr-2 mt-2">
                  <div v-if="!multipleStats">
                    <div>
                      ({{ statHoursWorked }}hrs./{{ statDaysWorked }} days)
                    </div>
                    <div v-if="statExemptDays > 0">
                      ({{ statExemptDays }} stat exempt day{{
                        statExemptDays != 1 ? 's' : ''
                      }})
                    </div>
                    <div v-if="statExemptHours > 0">
                      ({{ statExemptHours }} stat exempt hour{{
                        statExemptHours != 1 ? 's' : ''
                      }})
                    </div>
                  </div>
                  <div v-else>
                    <div>Sum of multiple stats</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- /totals -->

        <payrollReportTablev2
          v-if="oneEmployeeSelected"
          :employee="selectedEmployee"
          :searchDate="searchDate"
          @updateStatTotals="updateStatTotals"
          @updateTotals="updateTotals"
        ></payrollReportTablev2>
      </div>
    </div>
    <!-- /totals and table -->

    <!-- all employees report -->
      <allEmployeesPayrollv2
    v-show="dataLoaded"
      v-if="allEmployeesSelected && !hideEmployeeReport"
      id="allEmployeesTable"
      :hideEmployeesWithNoHours="hideEmployeesWithNoHours"
      :users="users"
      :fromHoursWorked="false"
      :searchDate="searchDate"
      @updateFromAllEmployees="updateFromAllEmployees"
    ></allEmployeesPayrollv2>
    <!-- 
      @isReportGenerating="isReportGenerating"

     -->
    <!-- /all employees report -->

    <!-- Send Email Modal -->
    <modal-wrapper :isOpen="showEmailModal">
      <div
        v-if="allEmployeesSelected"
        v-show="showEmailModal"
        id="editUser"
        class="customModal fade"
        v-bind:class="{ show: showEmailModal }"
      >
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h6 class="modal-title">Select Employees</h6>

              <button
                type="button"
                class="close"
                data-dismiss="modal"
                v-on:click="closeEmailModal()"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <div class="checkbox-container mb-4">
                <div class="checkbox-group">
                  <el-checkbox
                    v-model="selectAllEmployee"
                    @change="toggleAllSelectionEmployer"
                  ></el-checkbox>
                  <label @click="toggleAllSelectionEmployer" class="mr-2 label">
                    Select All Employees
                  </label>
                </div>
                <div class="checkbox-group" v-if="!sendEmailSelection">
                  <el-checkbox v-model="collatePdf"></el-checkbox>
                  <label class="mr-2 label">
                    Collate PDF
                  </label>
                </div>

                <div class="checkbox-group" v-if="!sendEmailSelection">
                  <el-checkbox v-model="reportSummary"></el-checkbox>
                  <label class="mr-2">
                    Report Summary
                  </label>
                </div>
              </div>
              <table class="table employeeSelectionTable">
                <thead>
                  <tr>
                    <th>
                      {{ sendEmailSelection ? 'Email' : 'Download' }}
                      Report
                    </th>

                    <th>Name</th>
                  </tr>
                </thead>
                <!-- allEmployeesReportData -->
                <tbody>
                  <tr
                    v-for="(employee, index) in users"
                    :key="`selection_${index}`"
                    @click="handleRowOrCheckboxClick(index - 1)"
                  >
                    <td v-if="index != 0">
                      <el-checkbox
                        v-model="multiUserSelection[index - 1]['pdf']"
                        @input="handleRowOrCheckboxClick(index - 1)"
                      ></el-checkbox>
                    </td>
                    <td v-if="index != 0">
                      {{ employee.name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer mt-4">
              <button
                type="button"
                class="btn btn-link"
                data-dismiss="modal"
                v-on:click="closeEmailModal()"
              >
                Close
              </button>
              <el-tooltip
                content="Please select an employee"
                class="item"
                effect="dark"
                placement="top"
                :disabled="!modalFlag"
              >
                <div>
                  <button
                    type="button"
                    class="btn bg-primary"
                    v-on:click="submitEmployeeSelection()"
                    :disabled="modalFlag"
                  >
                    <div v-if="modal_loading">Loading...</div>
                    <div v-if="!modal_loading">
                      <div v-if="!modal_loading">
                        {{ sendEmailSelection ? 'Send' : 'Download' }}
                        <i
                          :class="
                            sendEmailSelection
                              ? 'icon-mail5'
                              : 'icon-cloud-download'
                          "
                          class="ml-2"
                        ></i>
                      </div>
                    </div>
                  </button>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </modal-wrapper>
    <!-- /Send Email Modal -->
  </div>
</template>

<script>
import payrollReportTablev2 from '../childComponents/payrollReportTablev2.vue';
import allEmployeesPayrollv2 from '../childComponents/allEmployeesPayrollv2.vue';
import PayrollReportPDFv2 from '../childComponents/payrollReportPDFv2.vue';
import { db } from '../../assets/js/firebase/db.js';
import { SpringSpinner } from 'epic-spinners';
import ModalWrapper from '../modalWrapper.vue';
import progressComponent from '../childComponents/progressComponent.vue';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { generateDocDefinition } from '../reports/payrollSummaryPDF';
import pdfMake from 'pdfmake/build/pdfmake';
import _ from 'lodash';

export default {
  name: 'payrollReport',
  components: {
    payrollReportTablev2,
    PayrollReportPDFv2,
    allEmployeesPayrollv2,
    SpringSpinner,
    ModalWrapper,
    progressComponent
  },
  data() {
    return {
      modalFlag: false,
      areButtonsDisabled: true,
      isSearchDisabled: false,
      isLoaderDisabled: true,
      timeCardCollection: [],
      printData: [],
      printTotals: [],
      users: [],
      statError: null,
      selectedEmployee: null,
      searchEmployeeError: false,
      searchEmployeeMessage: null,
      searchDate: null,
      searchDateError: false,
      searchDateMessage: null,
      columnsToShow: [],
      employeesToShow: [],
      minDate: undefined,
      maxDate: undefined,
      disabledDays: [1, 2, 3, 4, 5, 6],
      pickerOptions: {
        disabledDate: time => {
          //only allow sundays and saturdays to be picked.
          let date = new Date(time).getDay();
          return this.disabledDays.includes(date);
        },
        onPick: ({ minDate, maxDate }) => {
          if (minDate && maxDate) {
            this.searchDate = [minDate, maxDate];
            this.closeDatePicker();

            // Reset disabledDays to use range selection after closing the calendar
            this.disabledDays = [1, 2, 3, 4, 5, 6];
          } else if (minDate && !maxDate) {
            const day = minDate.getDay();
            if (day === 0) {
              this.disabledDays = [0, 1, 2, 3, 4, 5];
            } else {
              this.resetPicker();
            }
          } else {
            this.resetPicker();
          }
        }
      },
      missingTimeCardError: false,
      missingTimeCardMessage: null,
      duplicateTimeCardErrors: [],
      allEmployeesSelected: false,
      oneEmployeeSelected: false,
      allEmployeesReportData: [],
      hideEmployeesWithNoHours: true,
      showEmailModal: false,
      allEmployeesCounter: 0,
      pdfOptions: {
        filename: null
      },
      emailPdf: false,
      multiUserSelection: [],
      sendEmailSelection: true,
      modal_loading: false,
      downloadKey: 0,
      emailKey: 1,
      printKey: 2,
      statDaysWorked: null,
      statHoursWorked: null,
      statExemptDays: null,
      statExemptHours: null,
      statTime: null,
      hideEmployeeReport: false,
      multipleStats: null,
      includeTimeCardData: true,
      pdfData: null,
      pdfTotals: null,
      pdfAllEmployeesReportData: null,
      jobSpecificTotals: [],
      selectAllEmployee: false,
      progressPercentage: 0,
      showProgress: false,
      isProgressComplete: false,
      collatePdf: false,
      blobsPdf: [],
      reportSummary: false,
      isDownloadableReport: false,
      printPdf: false,
      preparedReportData: null,
      updateCalls: 0,
      dataLoaded: false,
      allEmployeeTotals: null,
      allEmployeesStatTotals: [],
    };
  },
  methods: {
    getUsers: function() {
      db.collection('users')
        .where('company', '==', this.$store.state.userCompany)
        .orderBy('name', 'asc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if (this.$store.state.showInactiveEmployees == 'Yes') {
              this.users.push({
                id: doc.id,
                name: doc.data().name,
                email: doc.data().email,
                type: doc.data().type,
                averagingAgreement: doc.data().averagingAgreement ? true : false
              });
              this.multiUserSelection.push({
                name: doc.data().name,
                pdf: false,
                email: false
              });
            } else if (
              doc.data().deactiveDate == undefined ||
              doc.data().deactiveDate == null
            ) {
              this.users.push({
                id: doc.id,
                name: doc.data().name,
                email: doc.data().email,
                type: doc.data().type,
                averagingAgreement: doc.data().averagingAgreement ? true : false
              });
              this.multiUserSelection.push({
                name: doc.data().name,
                pdf: false,
                email: false
              });
            }
          });
          this.users.unshift({
            id: 'all',
            name: 'All Employees'
          });
        })
        .catch(err => {
          console.log('Error getting users.' + err);
        });
    },
    searchCards: async function() {
      this.hideEmployeeReport = false;
      if (this.validateSearch() === true) {
        /*if all employess are selected in the users dropdown, then show the all employees table,
        which we pass the users collection and the search date to */

        // reset the stat calculation totals
        this.statDaysWorked = null;
        this.statError = null;
        this.statExemptDays = null;
        this.statExemptHours = null;
        this.statHoursWorked = null;
        this.statTime = null;

        if (this.selectedEmployee.id == 'all') {
          //set all employees selected to true, so the all employees report shows and the weekly report and totals hide.
          this.oneEmployeeSelected = false;
          this.allEmployeesSelected = true;
          this.isSearchDisabled = true;
          this.isLoaderDisabled = false;
        } else {
          /*if one employee is selected then show the payrollReportTable component,
          which we pass the selected employee and search date to*/
          this.allEmployeesSelected = false;
          this.oneEmployeeSelected = true;
          this.isSearchDisabled = true;
          this.isLoaderDisabled = false;
        }
      }
    },
    validateSearch: function() {
      let flag = true;
      if (this.searchDate == null) {
        this.searchDateError = true;
        this.searchDateMessage = 'The date selection cannot be empty.';
        flag = false;
      } else {
        this.searchDateError = false;
        this.searchDateMessage = null;
        flag = true;
      }
      if (this.selectedEmployee == null) {
        this.searchEmployeeError = true;
        this.searchEmployeeMessage = 'The employee selection cannot be empty.';
        flag = false;
      } else {
        this.searchEmployeeError = false;
        this.searchEmployeeMessage = null;
        flag = true;
      }
      return flag;
    },
    dateChanged: function(time) {
      //if the calendar was cleared, then we need reset the limited dates in the calendar.
      if (time === null) {
        this.disabledDays = [1, 2, 3, 4, 5, 6];
        this.minDate = undefined;
        this.maxDate = undefined;
      }
    },
    resetReport: function() {
      if (this.selectedEmployee.id == 'all') {
        this.allEmployeesSelected = true;
      } else{
        this.allEmployeesSelected = false;
      }
    },
    disableButtons() {
      this.areButtonsDisabled = true;
    },
    enableButtons() {
      if (!this.searchDateError && !this.searchEmployeeError) {
        this.areButtonsDisabled = false;
        this.isLoaderDisabled = true;
      }
    },
    //updateStatTotals is emitted from the payrollReportTable component
    updateStatTotals: function(
      multipleStats,
      statHoursWorked,
      statDaysWorked,
      statExemptDays,
      statExemptHours,
      statError
    ) {
      this.multipleStats = multipleStats;
      this.statHoursWorked = statHoursWorked;
      this.statDaysWorked = statDaysWorked;
      this.statExemptDays = statExemptDays;
      this.statExemptHours = statExemptHours;
      this.statError = statError;
    },
    //updateTotals is emitted from the payrollReportTable component upon completion
    updateTotals: function(
      totals,
      data,
      employee,
      error,
      message,
      duplicateError,
      jobSpecificTotals
    ) {
      this.printTotals = totals;
      this.printData = data;
      this.missingTimeCardMessage = message;
      this.missingTimeCardError = error;
      this.duplicateTimeCardErrors = duplicateError;
      //manipulate data to match what we previously sent to the pdf components(download/email)
      this.pdfTotals = [{ employee: employee.id, totals: totals }];
      this.pdfData = [{ employee: employee.id, data: data }];
      this.jobSpecificTotals = jobSpecificTotals;
      let onCallHoursTotal = 0;
      let otTotal = 0;
      let regularTotal = 0;
      let statTotal = 0;
      let total = 0;
      let travelTimeTotal = 0;
      for (let i = 0; i < totals.length; i++) {
        onCallHoursTotal += Number(totals[i].onCallHoursTotal);
        otTotal += Number(totals[i].otTotal);
        regularTotal += Number(totals[i].regularTotal);
        statTotal += Number(totals[i].statTotal);
        total += Number(totals[i].total);
        travelTimeTotal += Number(totals[i].travelTimeTotal);
      }

      this.pdfAllEmployeesReportData = [
        {
          employee: employee.name,
          onCallHoursTotal: onCallHoursTotal,
          otTotal: otTotal,
          regularTotal: regularTotal,
          statTotal: statTotal,
          total: total,
          travelTimeTotal: travelTimeTotal
        }
      ];
      //enable disabled buttons
      this.enableButtons();
    },
    //updateFromAllEmployees is emitted from the allEmployeesPayroll component upon completion
    updateFromAllEmployees: function(
      totals,
      data,
      allData,
      error,
      message,
      duplicateErrors,
      jobSpecificTotals,
      hoursWorkedJobSpecificTotals,
      columnsToShow,
      employeesToShow,
      allEmployeesStatTotals
    ) {
      this.printTotals = totals;
      this.printData = data;
      this.allEmployeesReportData = allData;
      this.missingTimeCardError = error;
      this.missingTimeCardMessage = message;
      this.duplicateTimeCardErrors = duplicateErrors;
      this.jobSpecificTotals = jobSpecificTotals;
      this.columnsToShow = columnsToShow;
      this.employeesToShow = employeesToShow;
      this.allEmployeesStatTotals = allEmployeesStatTotals;
      //manipulate data to match what we previously sent to the pdf components
      this.pdfTotals = JSON.parse(JSON.stringify(totals));
      this.pdfData = JSON.parse(JSON.stringify(data));

      // add the employee stat totals to the pdfAllEmployeesReportData
      let allDataWithStatTotals = JSON.parse(JSON.stringify(allData));
      allDataWithStatTotals.forEach(employee =>{
        // find the employee's stat totals
        let employeeStatTotals = allEmployeesStatTotals.find(x => x.uid == employee.employee.id);

        if(employeeStatTotals){
          employee['statDaysWorked'] = employeeStatTotals.statDaysWorked;
          employee['statHoursWorked'] = employeeStatTotals.statHoursWorked;
          employee['statExemptDays'] = employeeStatTotals.statExemptDays;
          employee['statExemptHours'] = employeeStatTotals.statExemptHours;
        }
      })
      this.pdfAllEmployeesReportData = JSON.parse(JSON.stringify(allDataWithStatTotals));

      for (let i = 0; i < this.pdfTotals.length; i++) {
        this.pdfTotals[i].employee = this.pdfTotals[i].employee.id;
      }
      for (let i = 0; i < this.pdfData.length; i++) {
        this.pdfData[i].employee = this.pdfData[i].employee.id;
      }
      for (let i = 0; i < this.pdfAllEmployeesReportData.length; i++) {
        this.pdfAllEmployeesReportData[
          i
        ].employee = this.pdfAllEmployeesReportData[i].employee.name;
      }

      this.updateCalls++;
    },
    downloadReport: function() {
      this.emailPdf = false;
      this.allEmployeesCounter = 0;
      this.isDownloadableReport = true;

      //check to see if all employees are selected.
      if (this.allEmployeesSelected === true) {
        //show the modal.
        this.sendEmailSelection = false;
        this.deselectNoHourEmployees();

        this.showEmailModal = true;
      } else {
        return;
      }
    },
    emailReport: function() {
      try {
        this.allEmployeesCounter = 0;
        this.emailPdf = true;
        this.isDownloadableReport = false;

        this.deselectNoHourEmployees();
        //show the modal.
        this.sendEmailSelection = true;
        this.showEmailModal = true;
      } catch (err) {
        console.log(`Error calling the send email report function: ${err}`);
      }
    },
    printReport: function() {
      this.emailPdf = false;
      this.printPdf = true;
      this.allEmployeesCounter = 0;
      this.isDownloadableReport = false;

      //check to see if all employees are selected.
      if (this.allEmployeesSelected === true) {
        let docDefinition = generateDocDefinition(
          this.allEmployeesReportData,
          this.searchDate,
          this.jobSpecificTimes,
          this.jobSpecificTotals,
          this.columnsToShow,
          this.employeesToShow,
          this.jobs,
        );
        pdfMake.createPdf(docDefinition).print();
      } else {
        return;
      }
    },
    deselectNoHourEmployees: function() {
      //uncheck all of the employees that don't have hours if that selection is made by the user
      this.allEmployeesReportData.forEach(user => {
        let index = this.multiUserSelection.findIndex(
          o => o.name == user.employee.name
        );
        if (Number(user.total) <= 0) {
          this.multiUserSelection[index].email = false;
          this.multiUserSelection[index].pdf = false;
        } else {
          this.multiUserSelection[index].email = true;
          this.multiUserSelection[index].pdf = true;
        }
      });
    },
    closeEmailModal: function() {
      this.showEmailModal = false;
      this.selectAllEmployee = false;
    },
    submitEmployeeSelection: function() {
      this.modal_loading = true;
      this.selectAllEmployee = false;
      this.allEmployeesReportDownloaded();
    },
    allEmployeesReportDownloaded: async function() {
      const selectedEmployeesData = this.allEmployeesReportData.filter(
        employeeData =>
          this.multiUserSelection.some(
            userSelection =>
              userSelection.name === employeeData.employee.name &&
              userSelection.pdf
          )
      );
      this.allEmployeeTotals = selectedEmployeesData

      try {
        let totalEmployees = this.pdfAllEmployeesReportData.length;
        this.showProgress = true;

        if (this.allEmployeesCounter === 0) {
          this.blobsPdf = [];

          if (this.collatePdf && this.reportSummary) {
            let summaryDocDef = generateDocDefinition(
              selectedEmployeesData,
              this.searchDate,
              this.jobSpecificTimes,
              this.jobSpecificTotals,
              this.selectedColumnsToShow,
              selectedEmployeesData,
              this.jobs,
            );
            let summaryPDF = pdfMake.createPdf(summaryDocDef);
            let summaryBlob = await this.$refs.reportPDF.generatePDFBlob(
              'Summary_Report',
              summaryPDF,
              false
            );
            this.blobsPdf.push(summaryBlob);
          }
        }

        if (
          this.allEmployeesCounter >= totalEmployees - 1 &&
          !this.isProgressComplete
        ) {
          this.isProgressComplete = true;
        }

        if (
          this.allEmployeesCounter === this.pdfAllEmployeesReportData.length
        ) {
          this.allEmployeesCounter++;

          if (!this.emailPdf) {
            if (this.collatePdf) {
              let mergedPdfBlob = await this.$refs.reportPDF.mergePdfs(
                this.blobsPdf
              );
              saveAs(
                new Blob([mergedPdfBlob], { type: 'application/pdf' }),
                'All_Employees_Report.pdf'
              );
            } else {
              if (this.reportSummary) {
                  let summaryDocDef = generateDocDefinition(
                  selectedEmployeesData,
                  this.searchDate,
                  this.jobSpecificTimes,
                  this.jobSpecificTotals,
                  this.selectedColumnsToShow,
                  selectedEmployeesData,
                  this.jobs,
                );
                let summaryPDF = pdfMake.createPdf(summaryDocDef);
                let summaryBlob = await this.$refs.reportPDF.generatePDFBlob(
                  'Summary_Report',
                  summaryPDF,
                  false
                );
                this.$refs.reportPDF.zip.file(
                  'Summary_Report.pdf',
                  summaryBlob
                );
              }
              await this.$refs.reportPDF.downloadZipFile();
              this.$refs.reportPDF.zip = new JSZip();
            }
          }
          this.allEmployeesReportDownloaded();
          this.showProgress = false;
        } else if (
          this.allEmployeesCounter < this.pdfAllEmployeesReportData.length
        ) {
          let employeeData = this.pdfAllEmployeesReportData[
            this.allEmployeesCounter
          ];
          let user = this.users.find(o => o.name === employeeData.employee);
          this.selectedEmployee = user;

          if (
            !this.multiUserSelection[
              this.multiUserSelection.findIndex(o => o.name == user.name)
            ].pdf
          ) {
            this.allEmployeesCounter++;
            this.allEmployeesReportDownloaded();
            return;
          }

          if (this.printPdf && !this.emailPdf) {
            this.$refs.reportPDF.pdfgen(
              'Print',
              this.selectedEmployee,
              this.pdfAllEmployeesReportData,
              this.pdfTotals,
              this.pdfData,
              this.searchDate,
              this.allEmployeesCounter,
              true
            );
          } else if (this.emailPdf === true) {
            this.$refs.reportPDF.pdfgen(
              'Email',
              this.selectedEmployee,
              this.pdfAllEmployeesReportData,
              this.pdfTotals,
              this.pdfData,
              this.searchDate,
              this.allEmployeesCounter,
              true
            );
            await new Promise(resolve => setTimeout(resolve, 600));
          } else {
            let pdfDocDef = this.$refs.reportPDF.pdfgen(
              'Download',
              this.selectedEmployee,
              this.pdfAllEmployeesReportData,
              this.pdfTotals,
              this.pdfData,
              this.searchDate,
              this.allEmployeesCounter,
              true
            );
            let blob = await this.$refs.reportPDF.generatePDFBlob(
              this.selectedEmployee.name,
              pdfDocDef,
              this.collatePdf
            );
            if (this.collatePdf) {
              this.blobsPdf.push(blob);
            }
          }

          this.allEmployeesCounter++;
          this.showEmailModal = false;
          this.allEmployeesReportDownloaded();
        } else if (
          this.allEmployeesCounter >=
          this.pdfAllEmployeesReportData.length - 1
        ) {
          let user = this.users.find(o => o.id == 'all');
          this.selectedEmployee = user;
          this.showEmailModal = false;
          this.modal_loading = false;
          this.emailPdf = false;
          this.collatePdf = false;
          this.reportSummary = false;
        }
      } catch (error) {
        console.error('An error occurred while generating the report:', error);
      }
    },
    isModalButtonDisabled: function() {
      let tempFlag = true;
      this.multiUserSelection.forEach(e => {
        if (e.pdf === true) {
          tempFlag = false;
          return;
        }
      });
      this.modalFlag = tempFlag;
    },

    handleRowOrCheckboxClick(index) {
      if (index >= 0) {
        this.multiUserSelection[index]['pdf'] = !this.multiUserSelection[index][
          'pdf'
        ];
        this.isModalButtonDisabled();
      }
    },
    // Toggle selection state for all employers: select if none are selected, deselect if any are.

    toggleAllSelectionEmployer() {
      if (this.selectAllEmployee) {
        this.multiUserSelection.forEach(user => {
          user.pdf = true;
        });
      } else {
        this.multiUserSelection.forEach(user => {
          user.pdf = false;
        });
      }
    },
    showMessage: function(type, message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: type
      });
    },
    handleProgressComplete() {
      setTimeout(() => {
        this.showProgress = false;
        if (this.isDownloadableReport) {
          this.showMessage(
            'success',
            'The payroll report has been downloaded!'
          );
        }
      }, 1000);
    },
    closeDatePicker() {
      if (
        this.$refs.datePicker &&
        typeof this.$refs.datePicker.handleClose === 'function'
      ) {
        this.$refs.datePicker.handleClose();
      }
    },
    resetPicker() {
      this.minDate = undefined;
      this.maxDate = undefined;
      this.searchDate = [];
      this.disabledDays = [1, 2, 3, 4, 5, 6];
    },
    handleReportData(reportData) {
      // console.log('in parent reportData', reportData);
      this.preparedReportData = reportData;
    }
  },
  computed: {
    reportTotals: function() {
      let totals = {
        total: 0,
        regularTotal: 0,
        otTotal: 0,
        travelTimeTotal: 0,
        onCallHoursTotal: 0,
        statTotal: 0
      };
      //loop through the print totals and add up all of times for each week.
      for (let i = 0; i < this.printTotals.length; i++) {
        //total
        totals.total += Number(this.printTotals[i].total);
        //regular time
        totals.regularTotal += Number(this.printTotals[i].regularTotal);
        //overtime
        totals.otTotal += Number(this.printTotals[i].otTotal);
        //travel time
        totals.travelTimeTotal += Number(this.printTotals[i].travelTimeTotal);
        //on call time
        totals.onCallHoursTotal += Number(this.printTotals[i].onCallHoursTotal);
        //stat time
        totals.statTotal += Number(this.printTotals[i].statTotal);
      }

      return totals;
    },
    companyLogo: function() {
      return {
        url: this.$store.state.logoUrl,
        base64: this.$store.state.encodedLogo
      };
    },
    totalEmployees() {
      return this.pdfAllEmployeesReportData
        ? this.pdfAllEmployeesReportData.length
        : 0;
    },
    jobSpecificTimes() {
      return this.$store.state.jobSpecificTimes;
    },
    jobs() {
      return this.$store.state.jobs;
    },
    selectedColumnsToShow: function() {
      let totals = {
        regular: {
          name: 'Regular Hours',
          dataName: 'regularTotal',
          value: 0
        },
        ot: {
          name: 'OT Hours',
          dataName: 'otTotal',
          value: 0
        },
        travel: {
          name: 'Travel Hours',
          dataName: 'travelTimeTotal',
          value: 0
        },
        onCall: {
          name: 'On Call',
          dataName: 'onCallHoursTotal',
          value: 0
        },
        stat: {
          name: 'Stat Pay',
          dataName: 'statTotal',
          value: 0
        },
        total: {
          name: 'Total Hours',
          dataName: 'total',
          value: 0
        }
      };

      this.allEmployeeTotals.forEach(employee => {
        for (let key in totals) {
          if (Object.prototype.hasOwnProperty.call(totals, key)) {
            const dataName = totals[key].dataName;
            totals[key].value += employee[dataName] || 0;
          }
        }
      });
      
      Object.keys(totals).forEach(key => {
        totals[key].value = parseFloat(totals[key].value.toFixed(2));
      });

      return Object.values(totals).filter(column => column.value > 0);
    },
  },
  mounted() {
    this.getUsers();
    let allEmployeesTable = document.getElementById(
      'allEmployeesPayrollReport'
    );
    if (allEmployeesTable != null) {
      allEmployeesTable.style.display = 'none';
    }
  },
  watch: {
    selectedEmployee() {
      this.isSearchDisabled = false;
      this.hideEmployeeReport = true;
      this.missingTimeCardError = false;
      this.printTotals = [];
    },
    searchDate() {
      this.isSearchDisabled = false;
      this.hideEmployeeReport = true;
      this.missingTimeCardError = false;
      this.printTotals = [];
    },
    // Watcher for Changes in the List of Selected Users
    multiUserSelection: {
      deep: true,
      handler: function(newSelection) {
        // Checking if all selected users have a truthy 'pdf' property.
        const allSelected = newSelection.every(user => user.pdf);
        // Setting the value of the 'selectAllEmployee' property based on the result of the above operation.
        this.selectAllEmployee = allSelected;

        this.isModalButtonDisabled();
      }
    },
    updateCalls: {
      deep: true,
      handler: function(newVal) {
        this.debouncedCheck();
      }
    }
  },
  created() {
    this.debouncedCheck = _.debounce(() => {
      this.dataLoaded = true;
        this.enableButtons();
    }, 1500);
  },
};
</script>
